import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import { SimpleIcon } from '@/generic'

const IconLink = ({ className, icon, children, href, rel }) => {
  return (
    <a className={classnames('icon-link', className)} href={href} rel={rel}>
      <SimpleIcon icon={icon} />
      {children}
    </a>
  )
}

IconLink.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.object.isRequired,
  href: PropTypes.string.isRequired,
  rel: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

export default IconLink
